var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankProductAndServiceBudget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3116.000000, -504.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-Product-and-Service/Budget",
    transform: "translate(3116.000000, 504.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,27.0740741 C32,28.1333333 31.1,29 30,29 L2,29 C0.9,29 0,28.1333333 0,27.0740741 L14.631,27.0740741 L14.631,15.1891852 C14.014,15.0293333 13.4,14.8338519 12.796,14.5796296 C7.881,12.515037 4.977,7.85911111 5.054,3 C6.514,3.08859259 7.982,3.41792593 9.4,4.014 C12.456,5.29762963 14.732,7.58466667 16,10.2992593 C17.268,7.58466667 19.544,5.29762963 22.599,4.014 C24.017,3.41792593 25.486,3.08859259 26.946,3 C27.023,7.85911111 24.119,12.515037 19.204,14.5796296 C18.6,14.8338519 17.986,15.0293333 17.368,15.1891852 L17.368,27.0740741 L32,27.0740741 Z",
    id: 150
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankProductAndServiceBudget);
export default __webpack_public_path__ + "static/media/bank-product-and-service-budget.7415c29c.svg";
export { ForwardRef as ReactComponent };